import React from 'react';
import propTypes from 'prop-types';
import { Menu } from 'lucide-react';

// sticky header at the top of the OEP Updates main pane. shows the page title
// on desktop, and adds a "Carriers" button on mobile that opens the sidebar
// sheet (the current carrier's name replaces the page title so the mobile
// header always tells the user which carrier they're on).
/**
 * @param isBelowLayout - whether the viewport is below the layout breakpoint
 * @param currentCarrierName - name of the selected carrier (or falsy)
 * @param onOpenSidebar - called when the mobile "Carriers" button is pressed
 */
export default function MainHeader({
  isBelowLayout,
  currentCarrierName,
  onOpenSidebar
}) {
  const title =
    isBelowLayout && currentCarrierName
      ? currentCarrierName
      : 'Open Enrollment Updates';

  return (
    <div className='sticky top-0 z-10 -mx-4 -mt-4 flex items-center gap-3 border-b border-grey-lightest bg-grey-lightest px-4 py-3 lg:static lg:mx-0 lg:mt-0 lg:border-0 lg:bg-transparent lg:p-0'>
      {isBelowLayout && (
        <button
          type='button'
          onClick={onOpenSidebar}
          aria-label='Open carriers list'
          className='inline-flex items-center gap-2 rounded-md border border-grey-lightest bg-white px-3 py-1.5 text-sm font-medium text-gray-800 shadow-sm hover:bg-primary-lighter focus:outline-none focus-visible:ring-2 focus-visible:ring-primary'
        >
          <Menu className='size-4' aria-hidden />
          Carriers
        </button>
      )}
      <h1 className='m-0 truncate text-xl font-bold text-black lg:text-3xl'>
        {title}
      </h1>
    </div>
  );
}

MainHeader.propTypes = {
  isBelowLayout: propTypes.bool.isRequired,
  currentCarrierName: propTypes.string,
  onOpenSidebar: propTypes.func.isRequired
};
